const Config = {
  apiBaseUrl: '/api',
  externalImageBaseUrl: 'https://hpx-tv-image.xsd.cz',
  domain: 'https://tvprogram.centrum.cz'
} as const

export default Config
